import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'
import { LayoutUtils } from '@/utils/LayoutUtils'
import GradientText from '@/scenes/Editor/components/GradientText/GradientText'

export const ToolButton = styled('button', ({ $selected, isDisabled }: { $selected?: boolean; isDisabled?: boolean }) => ({
  width: `${LayoutUtils.ADD_MENU_TEXT_BUTTONS_BUTTON_SIZE}px`,
  height: `${LayoutUtils.ADD_MENU_TEXT_BUTTONS_BUTTON_SIZE}px`,
  borderRadius: '8px',
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  padding: 0,
  cursor: isDisabled ? 'default' : 'pointer',
  opacity: isDisabled ? 0.4 : 1,
  background: $selected ? lightTheme.colors.grayScale100 : 'transparent',
  transition: 'background 0.15s ease',
  ':hover': isDisabled || $selected ? {} : { background: lightTheme.colors.grayScale50 },
}))

type ToolButtonLabelVariant = 'default' | 'gradient'

const StyledToolButtonLabel = styled('span', {
  display: 'inline-block',
  maxWidth: `${LayoutUtils.ADD_MENU_TEXT_BUTTONS_BUTTON_SIZE}px`,
  fontSize: '9px',
  lineHeight: '16px',
  fontWeight: 600,
  letterSpacing: '0.09px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: lightTheme.colors.blackGray,
})

/** 'gradient' paints the label in the brand gradient its icon is filled with —
 *  GradientText owns the gradient, this span keeps the rail's size/truncation. */
export const ToolButtonLabel = ({ text, variant = 'default' }: { text: string; variant?: ToolButtonLabelVariant }) => (
  <StyledToolButtonLabel title={text}>
    {variant === 'gradient' ? <GradientText>{text}</GradientText> : text}
  </StyledToolButtonLabel>
)

